import { ThemeOptions } from '@mui/material';

const RichTreeView = (theme: ThemeOptions) => ({
  MuiTreeView: {
    styleOverrides: {
      root: {
        direction: theme.direction,
        '& .MuiTreeItem-content': {
          flexDirection: theme.direction === 'rtl' ? 'row-reverse' : 'row',
          justifyContent: theme.direction === 'rtl' ? 'flex-end' : 'flex-start',
          textAlign: theme.direction === 'rtl' ? 'right' : 'left'
        },
        '& .MuiTreeItem-group': {
          marginLeft: theme.direction === 'rtl' ? 'auto' : '17px',
          marginRight: theme.direction === 'rtl' ? '17px' : 'auto',
          paddingLeft: theme.direction === 'rtl' ? '0' : '0',
          paddingRight: theme.direction === 'rtl' ? '0' : '0'
        },
        '& .MuiTreeItem-root': {
          '&::before': {
            left: theme.direction === 'rtl' ? 'auto' : '16px',
            right: theme.direction === 'rtl' ? '16px' : 'auto'
          }
        }
      }
    }
  },
  MuiTreeItem2: {
    styleOverrides: {
      root: {
        direction: theme.direction,
        '& .MuiTreeItem2-content': {
          flexDirection: theme.direction === 'rtl' ? 'row-reverse' : 'row',
          justifyContent: theme.direction === 'rtl' ? 'flex-end' : 'flex-start',
          textAlign: theme.direction === 'rtl' ? 'right' : 'left'
        },
        '& .MuiTreeItem2-group': {
          marginLeft: theme.direction === 'rtl' ? 'auto' : '17px',
          marginRight: theme.direction === 'rtl' ? '17px' : 'auto',
          paddingLeft: theme.direction === 'rtl' ? '0' : '0',
          paddingRight: theme.direction === 'rtl' ? '0' : '0'
        },
        '&::before': {
          left: theme.direction === 'rtl' ? 'auto' : '16px',
          right: theme.direction === 'rtl' ? '16px' : 'auto'
        }
      }
    }
  }
});

export default RichTreeView;
